import { clsx } from "clsx";
import { useCallback, useState } from "react";

import { useMediaPlayerContext } from "./context";
import { MediaProgressGroup } from "./MediaProgressGroup";

export interface MediaChapterProps {
  end: number;
  playheadValue: number;
  pointerValue: number;
  start: number;
}

export function MediaChapter({
  end,
  start,
  playheadValue,
  pointerValue,
}: MediaChapterProps) {
  const { duration } = useMediaPlayerContext();
  const [isActive, setIsActive] = useState(false);

  const width = (end - start) / duration;

  // Gets the percentage value relative to the chapter range
  function getPercentValue(from: number) {
    return end < from ? 1 : Math.max(0, (from - start) / (end - start));
  }

  const percentComplete = getPercentValue(duration * playheadValue);
  const percentScrub = getPercentValue(duration * pointerValue);

  const className = clsx("MediaChapter", {
    "MediaChapter--active": isActive,
  });

  const handleMouseEnter = useCallback(() => {
    setIsActive(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsActive(false);
  }, []);

  return (
    <div
      className={className}
      style={{ width: `calc(${width * 100}% - 2px)` }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <MediaProgressGroup
        end={end}
        playheadValue={percentComplete}
        pointerValue={percentScrub}
        start={start}
      />
    </div>
  );
}
